import styled from 'styled-components';

export const TD = styled.td``;
